import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

// 创建认证上下文
const AuthContext = createContext();

// API相对路径
const API_PATH = '/api/v1';

// 认证提供者组件
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // 检查本地存储中是否有doctor_token
    const checkAuth = async () => {
      const token = localStorage.getItem('doctor_token');
      if (token) {
        try {
          // 获取医生个人信息以验证token是否有效
          const response = await axios.get(`${API_PATH}/doctors/profile`, {
            withCredentials: true
          });
          
          setCurrentUser(response.data);
          setIsAuthenticated(true);
        } catch (error) {
          // Token无效，清除本地存储
          localStorage.removeItem('doctor_token');
          setIsAuthenticated(false);
          setCurrentUser(null);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  // 登录函数
  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API_PATH}/doctors/login`, {
        username,
        password
      }, {
        withCredentials: true
      });
      
      // 保存token到本地存储
      if (response.data.token) {
        localStorage.setItem('doctor_token', response.data.token);
      }
      
      // 更新认证状态
      setCurrentUser(response.data.doctor);
      setIsAuthenticated(true);
      
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // 登出函数
  const logout = async () => {
    try {
      await axios.post(`${API_PATH}/doctors/logout`, {}, {
        withCredentials: true
      });
    } catch (error) {
      console.error('登出错误', error);
    } finally {
      // 即使API调用失败，也清除本地状态
      localStorage.removeItem('doctor_token');
      setCurrentUser(null);
      setIsAuthenticated(false);
    }
  };

  const value = {
    currentUser,
    loading,
    isAuthenticated,
    login,
    logout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// 使用认证上下文的hook
export const useAuth = () => {
  return useContext(AuthContext);
}; 